import { render } from "./Section0Hero.vue?vue&type=template&id=00c6aa74&scoped=true"
const script = {}

import "./Section0Hero.vue?vue&type=style&index=0&id=00c6aa74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c6aa74"]])

export default __exports__